<template>
  <div
    class="card-body border rounded mb-4"
    :class="theme == 'light' ? 'bg-white' : 'border-info'"
  >
    <div class="card-title mb-2 d-flex justify-content-between">
      <h5 class="">
        {{ $t("dashboards.top-malware") }} <br /><span class="text-info"
          >25 {{ $t("dashboards.day") }}</span
        >
      </h5>
      <div>
        <b-button
          :variant="charttype == 'line' ? 'primary' : 'outline-primary'"
          size="sm"
          class="mr-2"
          title="Line Chart"
          @click="changeType('line')"
        >
          <i class="bx bxs-chart font-size-24 align-middle"></i>
        </b-button>
        <b-button
          :variant="charttype == 'bar' ? 'primary' : 'outline-primary'"
          size="sm"
          title="Bar Chart"
          @click="changeType('bar')"
        >
          <i class="bx bxs-bar-chart-square font-size-24 align-middle"></i>
        </b-button>
      </div>
    </div>
    <div v-if="loading.top">
      <div class="text-center py-4 my-5">
        <i class="bx bx-loader-circle bx-spin bx-md"></i> <br />
        <span class="font-size-16"> Loading ... </span>
      </div>
    </div>
    <div v-if="!loading.top && series[0]">
      <apexchart
        class="apex-charts"
        :type="charttype"
        dir="ltr"
        height="440"
        :series="series"
        :options="{
          legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'center',
            floating: false,
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: undefined,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
              colors: '#fff',
              useSeriesColors: false,
            },
            markers: {
              width: 12,
              height: 12,
              strokeWidth: 0,
              strokeColor: '#fff',
              fillColors: undefined,
              radius: 12,
              customHTML: undefined,
              onClick: undefined,
              offsetX: 0,
              offsetY: 0,
            },
            itemMargin: {
              horizontal: 5,
              vertical: 4,
            },
            onItemClick: {
              toggleDataSeries: true,
            },
            onItemHover: {
              highlightDataSeries: true,
            },
          },
          chart: {
            zoom: {
              enabled: true,
            },
            toolbar: {
              show: true,
            },
            redrawOnParentResize: true,
          },
          colors: ['#E2A040', '#53A9DA', '#E7515A', '#009688'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: [2, 2, 2],
          },
          title: {
            text: 'Daily Comulative Report',
            align: 'left',
          },
          markers: {
            size: 0,

            hover: {
              sizeOffset: 6,
            },
          },
          xaxis: {
            categories: days,
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val.toFixed(0);
              },
            },
          },
          grid: {
            show: true,
            strokeDashArray: 0.3,
            borderColor: '#000', // you can either change hear to disable all grids
            xaxis: {
              lines: {
                show: false, //or just here to disable only x axis grids
              },
            },
            yaxis: {
              lines: {
                show: true, //or just here to disable only y axis
              },
            },
          },

          chart: {
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
            redrawOnParentResize: true,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '70%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: days,
          },
          colors: [
            '#84cc16',
            '#3b82f6',
            '#6f42c1',
            '#e83e8c',
            '#E7515A',
            '#e95f2b',
            '#14b8a6',
            '#e2a03f',
            '#009688',
            '#53A9DA',
            '#ef4444',
            '#8b5cf6',
          ],
        }"
      ></apexchart>
    </div>
    <div v-if="!loading.recap && !series[0]">
      <div class="m-5 p-5">
        <div class="text-center py-4 my-5">
          <span class="py-5 my-5"> {{ $t("dashboards.data-not-found") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ElasticService from "@/helpers/elastic.service";
import PreferencesServices from "@/helpers/preferences.service";
import { userService } from "@/helpers/authservice/user.service";

export default {
  data() {
    return {
      theme: localStorage.getItem("theme"),
      series: [],
      days: [],
      loading: {
        top: false,
      },
      charttype: "bar",
      sandBoxData: [],
      pref_ahn: "",
      pref_cp: "",
    };
  },
  methods: {
    getPreferences() {
      let ferr = 0;
      PreferencesServices.getByKey("elastic", "ahn_lab")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferences();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            this.pref_ahn = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferences();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        })
        .finally(() => {
          // this.getAhnLab();
        });
    },

    getPreferencesCP() {
      let ferr = 0;
      PreferencesServices.getByKey("elastic", "checkpoint")
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getPreferencesCP();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.totalUser = [];
            this.pref_cp = response.data.data;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getPreferencesCP();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
            }
          }
        })
        .finally(() => {
          this.getCheckpoint();
        });
    },

    getLast25() {
      const ordered = _.orderBy(this.sandBoxData, (res) => res.index_time);

      const groupClass = _.groupBy(this.sandBoxData, "type");
      const orderClass = _.orderBy(
        groupClass,
        [
          function (o) {
            return o.length;
          },
        ],
        ["desc"]
      );

      _.map(_.values(orderClass), (arr, idx) => {
        if (idx < 10) {
          const dataClass = {
            name: arr[0].type,
            data: [],
          };

          this.series.push(dataClass);
        }
      });

      this.days.forEach((day) => {
        this.series.forEach((ser, idx) => {
          const count = ordered.reduce((accumulator, element) => {
            if (
              element.index_time ==
                moment(day, "DD-MMM-YY").format("DD-MM-YYYY") &&
              element.type === ser.name
            ) {
              return accumulator + 1;
            }

            return accumulator;
          }, 0);
          this.series[idx].data.push(count);
        });
      });

      // console.log("Test ", this.series);

      setTimeout(() => {
        this.loading.top = false;
      }, 500);
    },

    getDays() {
      let tempD = moment().subtract(25, "days").format("DD-MM-YYYY");
      for (let i = 0; i < 25; i++) {
        this.days.push(
          moment(tempD, "DD-MM-YYYY").add(1, "days").format("DD-MMM-YY")
        );
        tempD = moment(tempD, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY");
      }
    },

    getCheckpoint() {
      this.loading.top = true;
      this.sandboxData = [];
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [
                    {
                      bool: {
                        should: [
                          {
                            range: {
                              detect_time: {
                                gt: moment()
                                  .subtract(24, "days")
                                  .format("YYYY-MM-DD"),
                              },
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            range: {
                              detect_time: {
                                lte: moment()
                                  .add(1, "days")
                                  .format("YYYY-MM-DD"),
                              },
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                },
              },
            ],
            should: [],
            must_not: [],
          },
        },
      };
      if (this.pref_cp.username && this.pref_cp.password) {
        let us = this.pref_cp.username;
        let ps = this.pref_cp.password;
        let base = this.encode(us, ps);
        var basedata_cp = "Basic " + base + "";
      } else {
        var basedata_cp = null;
      }

      ElasticService.getCheckpointLab(
        this.pref_cp.api_host,
        bodyQuery,
        basedata_cp
      )
        .then((response) => {
          // console.log('cp top',  response.data.hits.hits);
          response.data.hits.hits.forEach((ele) => {
            if (ele._source.av.malware_info) {
              var signa_cp = ele._source.av.malware_info.signature_name;
            } else {
              var signa_cp = "Unknown";
            }
            // console.log('sname', ele);
            const item = {
              index_time: moment(ele._source.detect_time).format("DD-MM-YYYY"),
              type: signa_cp,
            };
            this.sandBoxData.push(item);
          });
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading.top = false;
          }, 500);
          console.log(err);
        })
        .finally(() => {
          this.getAhnLab();
        });
    },

    getAhnLab() {
      let bodyQuery = {
        size: 100,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [
                    {
                      bool: {
                        should: [
                          {
                            range: {
                              "detect_time.keyword": {
                                gt: moment()
                                  .subtract(24, "days")
                                  .format("YYYY-MM-DD"),
                              },
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                    {
                      bool: {
                        should: [
                          {
                            range: {
                              "detect_time.keyword": {
                                lte: moment()
                                  .add(1, "days")
                                  .format("YYYY-MM-DD"),
                              },
                            },
                          },
                        ],
                        minimum_should_match: 1,
                      },
                    },
                  ],
                },
              },
            ],
            should: [],
            must_not: [],
          },
        },
      };
      if (this.pref_ahn.username && this.pref_ahn.password) {
        let us = this.pref_ahn.username;
        let ps = this.pref_ahn.password;
        let base = this.encode(us, ps);
        var basedata_ahn = "Basic " + base + "";
      } else {
        var basedata_ahn = null;
      }

      ElasticService.getAhnLab(this.pref_ahn.api_host, bodyQuery, basedata_ahn)
        .then((response) => {
          // console.log('ahn top', response.data.hits.hits);
          response.data.hits.hits.forEach((ele) => {
            if (ele._source.detect_name) {
              var detect_name_ahn = ele._source.detect_name;
            } else {
              var detect_name_ahn = "Unknown";
            }
            const item = {
              index_time: moment(ele._source.detect_time).format("DD-MM-YYYY"),
              type: detect_name_ahn,
            };
            this.sandBoxData.push(item);
          });
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading.top = false;
          }, 500);
          console.log(err);
        })
        .finally(() => {
          this.getLast25();
        });
    },

    changeType(type) {
      this.charttype = type;
    },

    encode(us, ps) {
      let usps = us + ":" + ps;
      return Buffer.from(usps).toString("base64");
      // console.log('hsl', usps, hsl);
    },
  },
  mounted() {
    this.getDays();
    this.getPreferences();
    this.getPreferencesCP();
  },
};
</script>
